/**
 * ProcessActionButtonElement — kreator formatek: klocek palety „Przycisk akceptacji”
 * (`process_action_button`, patrz `RecursiveFormRenderer` PLACEHOLDER_TYPES).
 *
 * Autor układu stawia go w dowolnej sekcji; na stronie rekordu zachowuje się dokładnie jak jedno
 * miejsce paska akceptacji nad zakładkami: przy wolnym slocie „Wyślij do akceptacji”, przy sprawie
 * w toku tylko „Akceptacja” (dla osoby mogącej teraz decydować), w pozostałych przypadkach nic
 * (`ProcessActionButton`). Bez „Anuluj proces”, bez ustawień i bez panelu właściwości.
 *
 * Jak `ProcessViewElement` — na REALNEJ stronie rekordu ten typ obsługują wyłącznie
 * `contextRenderers['process_action_button']` (7 klas dokumentów przez
 * `buildDocumentAdditionalRenderers`, kontrahenci lokalną mapą w `ContractorDetail.tsx`) oraz
 * `renderProcessLayoutElement` w `RecordFormPage` (moduły własne). Ten plik obsługuje TYLKO podgląd
 * w canvasie buildera (`mode='builder'`) — nieinteraktywną zaślepkę.
 *
 * `allowedModules` — te same hosty co „Proces akceptacji” (`PROCESS_ELEMENT_ALLOWED_MODULES`).
 *
 * `icon: 'Send'` — jak „Wyślij do akceptacji”, główna czynność tego przycisku.
 */

import { Send } from 'lucide-react';

import type { LayoutElementDefinition } from '@/components/fields/LayoutElementRegistry';
import i18n from '@/i18n';

import { PROCESS_ELEMENT_ALLOWED_MODULES } from './ProcessViewElement';

export const ProcessActionButtonElement: LayoutElementDefinition = {
  type: 'process_action_button',
  category: 'tresc',
  isContainer: false,
  label: 'Przycisk akceptacji',
  icon: 'Send',
  allowedModules: [...PROCESS_ELEMENT_ALLOWED_MODULES],
  defaultSettings: () => ({}),
  render: ({ element }) => (
    <div
      className="inline-flex items-center gap-1.5 rounded-md border border-dashed border-border-secondary bg-bg-secondary px-3 py-1.5 text-xs font-medium text-text-secondary"
      data-testid={`process-action-button-element-${element.id}`}
      data-element-type="process_action_button"
    >
      <Send className="h-3.5 w-3.5 text-text-muted" aria-hidden="true" />
      {i18n.t('tenant.processes.actionButton.paletteLabel', {
        defaultValue: 'Przycisk akceptacji',
      })}
    </div>
  ),
};
